export default "__VITE_ASSET__BhFhNRfz__"